import { render, staticRenderFns } from "./onboardingComplete.vue?vue&type=template&id=04e5415e&scoped=true&"
import script from "./onboardingComplete.vue?vue&type=script&lang=js&"
export * from "./onboardingComplete.vue?vue&type=script&lang=js&"
import style0 from "./onboardingComplete.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./onboardingComplete.vue?vue&type=style&index=1&id=04e5415e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5415e",
  null
  
)

export default component.exports